import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";

const FeedbackModal = ({ isOpen, onClose, onSubmit, stepId }) => {
  const [input, setInput] = useState("");

  const handleSubmit = () => {
    onSubmit(stepId, input);
    setInput("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-[100]">
      <div
        className="bg-black bg-opacity-50 absolute inset-0"
        onClick={onClose}
      />
      <div className="bg-zinc-900 text-zinc-100 w-96 rounded-lg flex flex-col z-10">
        <div className="flex justify-between items-center border-b border-zinc-800 px-4 py-3">
          <h2 className="text-lg font-semibold">Add Feedback</h2>
          <button
            onClick={onClose}
            className="p-1 hover:bg-zinc-800 rounded-lg transition-colors"
          >
            <IoMdClose className="w-5 h-5" />
          </button>
        </div>
        <div className="p-4">
          <textarea
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Enter your feedback..."
            className="w-full p-3 border rounded-md bg-zinc-800 border-zinc-700 min-h-32 focus:outline-none focus:border-zinc-600"
          />
        </div>
        <div className="border-t border-zinc-800 p-4 flex justify-end">
          <button
            onClick={handleSubmit}
            className="bg-zinc-800 hover:bg-zinc-700 text-white py-2 px-4 rounded-md transition duration-150"
          >
            Send Feedback
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;
